import React from "react";
import PropTypes from "prop-types";

import SectionBody from "./SectionBody";
import SectionCommunity from "./SectionCommunity";
import SectionFeature from "./SectionFeature";
import SectionGallery from "./SectionGallery";
import SectionNavigation from "./SectionNavigation";
import SectionNews from "./SectionNews";
import SectionPreorder from "./SectionPreorder";

const Sections = (props) => {
  const { items, location, settings } = props;

  function oddEven(x) {
    return x & 1 ? "odd" : "even";
  }

  const Components = {
    section_body: SectionBody,
    section_community: SectionCommunity,
    section_feature: SectionFeature,
    section_gallery: SectionGallery,
    section_navigation: SectionNavigation,
    section_news: SectionNews,
    section_preorder: SectionPreorder,
  };

  return (
    <>
      {items &&
        items.map((node, index) => {
          const item = node;

          if (typeof Components[item.component] !== "undefined") {
            const Component = Components[item.component];
            return (
              <Component
                doc={item}
                key={item._uid}
                location={location}
                oddEven={oddEven(index)}
                settings={settings}
              />
            );
          }
          return null;
        })}
    </>
  );
};

export default Sections;

Sections.propTypes = {
  items: PropTypes.array,
};

Sections.defaultProps = {
  items: null,
};
